import React, { Component } from 'react'
import { BrowserRouter, Route } from 'react-router-dom'
import { connect } from 'react-redux'
import { SpaErrorPage } from './components'
import { SpaCruiseNotFoundPage } from './components'
import { SpaLandingPage } from './components'
import { SpaServices } from './components'
import { SpaReserve } from './components'
import { PrivateRoute } from './utils/PrivateRoute'
import { stickyComponents } from './utils/spaConstants'
import { initializeIdleTimeout } from './actions/user.actions';

import { createBrowserHistory } from 'history';
import SpaHeader from './components/Header/SpaHeader'
export const history = createBrowserHistory();

class App extends Component {
    componentDidMount() {
        this.props.actions.initializeIdleTimeout()
	// PCSIWSC-8438 Adding Adobe Tag
        const script = document.createElement("script");
        script.src = "https://www.princess.com/js/global/tag-manager-pcl.js";
        script.id = "digital-data-tracking";
        script.async = true;
        document.head.appendChild(script);
    }
    
    render() {
        return (
            <>
                <SpaHeader/>
                <BrowserRouter basename={'lotus-spa'} history={history}>
                    <Route exact path="/" component={SpaLandingPage} />
                    <PrivateRoute path="/spaservices" component={SpaServices} />
                    <PrivateRoute path="/reserve/:spaId?" component={SpaReserve} />
                    <Route path="/error" component={SpaErrorPage} />
                    <Route path="/cruisenotfound" component={SpaCruiseNotFoundPage} />
                    {/* <Route component={() => { window.location = 'https://stagewww.princess.com/pagenotfound'; return null;} }/> */}
                    {/* <PrivateRoute path="/test" component={SpaServices} /> */}
                </BrowserRouter>
            </>


        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        actions: {
            initializeIdleTimeout: (url) => dispatch(initializeIdleTimeout(url)),
        }
    }
}

export default connect(
    null,
    mapDispatchToProps
)(App);